const d = document;

/**
 * IRニュースメニューリスト生成クラス
 */
export default class IRNewsMenuList {
  /**
   * inputのnameに使うid
   * @private
   */
  static #nextId = 0;

  /**
   * inputのname発行
   * @return {String} inputのname
   */
  static getInputName() {
    return 'IRNewsMenuList' + (++this.#nextId);
  }

  /** 設定 */
  config = null;

  /** テンプレート */
  template = `
  <li><label class="button--radio"><input type="radio" name="#{inputName}" value="#{doctype}"#{inputChecked}><span class="button__text">#{doctypeLabel}</span></label></li>
  `;

  /** リスト要素 */
  $menu = null;

  /** リスト生成クラスのインスタンス */
  list = null;

  /** inputのname */
  inputName = '';

  /**
   * コンストラクタ
   * @param {Object} config 設定
   * @param {HTMLSelectElement} $menu メニューリスト要素
   * @param {IRNewsList} list リスト
   */
  constructor(config, $menu, list) {
    this.config = config;
    this.$menu = $menu;
    this.list = list;
    this.inputName = this.constructor.getInputName();
    this.rendar();
  }

  /**
   * テンプレート埋め込み用のパラメータを取得
   * @param {String} doctypePropName 種別プロパティ名
   * @return {Object} 埋め込み用パラメータのオブジェクト
   */
  getRendarProperties(doctypePropName) {
    const doctypeLabel = this.config.getDoctypeLabel(doctypePropName);
    const props = {
      inputName: this.inputName,
      doctype: doctypePropName,
      doctypeLabel: doctypeLabel,
    };
    return props;
  }

  /**
   * リストを空にする
   */
  clearMenu() {
    this.$menu.innerHTML = '';
  }

  /**
   * レンダリング
   */
  rendar() {
    this.clearMenu();

    const $menu = this.$menu
    const config = this.config;
    const doctypes = config.getDoctypes();
    for (const key of Object.keys(doctypes)) {
      $menu.appendChild(this.rendarItem(key));
    }
  }

  /**
   * リストアイテムのレンダリング
   * @param {String} doctypePropName 種別プロパティ名
   * @return {Element} リストアイテムの要素
   */
  rendarItem(doctypePropName) {
    // テンプレート埋め込み用変数リスト
    const props = this.getRendarProperties(doctypePropName);
    props.inputChecked = (doctypePropName === 'all') ? ' checked' : '';

    // テンプレートにデータを反映
    const $temp = d.createElement('ul');
    $temp.innerHTML = this.template.replace(/#\{([^}]+)\}/g, (matched, property) => {
      return props[property]
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
      ;
    });

    const $el = $temp.children[0];
    $el.querySelector(`input[name="${this.inputName}"]`)
      .addEventListener(
        'input',
        this.onSelect.bind(this),
        { passive: true }
      )
    ;
    return $el;
  }

  /**
   * メニュー選択
   * @param {String} doctypePropName 種別プロパティ名
   */
  select(doctypePropName) {
    this.list.doctype = doctypePropName;
    this.list.load();
  }

  /**
   * 選択イベント
   * @param {Event} e イベント
   */
  onSelect(e) {
    const $input = e.target;
    const doctypePropName = $input.getAttribute('value');
    this.select(doctypePropName);
  }
}
